import React from 'react'
import styles from './login.module.css'
import { useNavigate } from 'react-router-dom'
import { ArrowIcon, LogoIcon,} from '../../../svg';

const Success = () => {

    const navigate = useNavigate();
    
    return (
        <div className={styles.container}>
            <div className={styles.main}>
                <div className={styles.mainContainer}>
                    <LogoIcon/>
                </div>
                <div className={styles.login}>

                    <div className={styles.content} style={{ marginTop: 20 }}>
                        <h3 style={{ marginTop: 100 }}>Password reset successfully!</h3>
                        <p>Your password has been reset successfully!</p>
                        
                        <div className={styles.google}>
                            <div className={styles.saveButtonStyle} onClick={()=> navigate('/login')} style={{ marginTop: 30 }}>
                                Login Now
                                <ArrowIcon />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}



export default Success;
